<template lang="pug">
#NavBar
  b-navbar(variant="light-primary" style="height: 65px;")
    img(v-if="mostrar" src="../../../public/mini-logo-azul.png" style="height:26px; margin:5px")
    button.boton#boton(v-if="mostrar" @click="show")
      b-icon(icon="list" style="width: 40px; height: 40px;" class="rounded-circle bg-light p-2" variant="primary")
    b-navbar-nav(class="ml-auto")
      b-nav-item-dropdown(right)
        template(v-slot:button-content)
          span#UserName {{fullName}}
        b-dropdown-item(@click="logout") 
          font-awesome-icon.sesion-item(:icon="['fas', 'sign-out-alt']" size="lg" style="margin-right:5px" )
          span.sesion-item  Cerrar Sesión
  b-navbar-nav.menu#menu(vertical)
    img(src="../../../public/dominguez_blanco.svg" style="width:150px; margin-left:13px")
    b-icon.btn-hide-menu(@click="show" icon="list" style="width: 40px; height: 40px;" class="rounded-circle bg-light p-2" variant="primary")
    .contenido
      b-nav-item.item(:to="'/'" exact)
        font-awesome-icon.imagen(:icon="['fas', 'home']" size="lg" style="color:white")
        span(style="color:white") Inicio
      b-nav-item.item(v-if="user.role==='owner'" :to="'/usuarios'")
        font-awesome-icon.imagen(:icon="['fas', 'users']" size="lg" style="color:white")
        span(style="color:white") Usuarios

      b-nav-item.item(v-if="user.role==='owner'" :to="'/servicios'")
        font-awesome-icon.imagen(:icon="['fas', 'briefcase']" size="lg" style="color:white")
        span(style="color:white") Servicios

      b-nav-item.item(v-if="checkRole(['owner', 'collaborator'])" :to="'/empresas'")
        font-awesome-icon.imagen(:icon="['far', 'building']" size="lg" style="color:white")
        span(style="color:white") Empresa

      b-nav-item.item(v-if="checkRole(['owner'])" :to="'/grupos-empresas'")
        font-awesome-icon.imagen(:icon="['fas', 'city']" size="lg" style="color:white")
        span(style="color:white") Grupos

      b-nav-item.item(v-if="user.role==='owner'" :to="'/tareas'")
        font-awesome-icon.imagen(:icon="['fas', 'thumbtack']" size="lg" style="color:white")
        span(style="color:white") Tareas

      b-nav-item.item(v-if="checkRole(['owner', 'collaborator'])" :to="'/seguimiento-tareas'")
        font-awesome-icon.imagen(:icon="['fas', 'tasks']" size="lg" style="color:white") 
        span(style="color:white") Seguimiento de tareas

      b-nav-item.item(v-if="checkRole(['owner', 'collaborator'])" :to="'/documentos'")
        font-awesome-icon.imagen(:icon="['fas', 'cloud-upload-alt']" size="lg" style="color:white")
        span(style="color:white") Documentos

      b-nav-item.item(v-if="checkRole(['owner']) || user.allowCalendarView" :to="'/calendario'")
        font-awesome-icon.imagen(:icon="['far', 'calendar-alt']" size="lg" style="color:white")
        span(style="color:white") Calendario

      b-nav-item.item(v-if="checkRole(['owner'])" :to="'/notas'")
        font-awesome-icon.imagen(:icon="['far', 'sticky-note']" size="lg" style="color:white")
        span(style="color:white") Notas

      b-nav-item.item(v-if="checkRole(['owner'])" :to="'/email'")
        font-awesome-icon.imagen(:icon="['fas', 'envelope']" size="lg" style="color:white")
        span(style="color:white") Email
</template>

<script>
import { mapActions ,mapGetters} from 'vuex'
import color from '../../style/colors.scss'
export default {
  data() {
    return {
      fullName: {},
      mostrar: true
    }
  },
  created() {
    this.getUser();
  },
  destroyed(){
    document.getElementById('app').style.marginLeft='0'
    document.getElementById('app').style.transition='none'
  },
  methods: {
    ...mapActions('AuthenticationStore', ['logout']),
    getUser(){
      const user = JSON.parse(localStorage.getItem('user')).user;
      this.fullName = `${user.name} ${user.lastName}`;
    },
    show(){
      if(this.mostrar){
        if (!this.inMobile()) {
          document.getElementById('app').style.marginLeft='250px'
        }
        document.getElementById('menu').style.marginLeft='250px'
        document.getElementById('app').style.transition='0.3s'
        this.mostrar=false
      } else {
        document.getElementById('menu').style.marginLeft='-250px'
        document.getElementById('app').style.marginLeft='0'
        document.getElementById('app').style.transition='0.3s'
        this.mostrar=true
      }
    },
    checkRole (roles) {
      return roles.includes(this.user.role)
    },
    inMobile () {
      return 700 > Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    }
  },
  computed:{
    ...mapGetters('AuthenticationStore', ['user'])
  }
}
</script>

<style lang="scss" scoped>

#UserName{
  color: #1C3FAA;
  font-weight: bold;
}
#menu {
  z-index: 99;
  background: #1C3FAA;
  height: 100%;
  width: 250px;
  position: fixed;
  top:0;
  left: -250px;
  padding: 20px;
  transition: 0.3s;
}
.btn-hide-menu {
  position: absolute;
  z-index: 100;
  top: 10px;
  right: 16px;
}
.boton{
  position: relative;
  background: transparent;
  border-color: transparent;
}
.boton:hover{
  background: transparent;
  border-color: transparent;
}
.boton:focus{
  outline: none;
}
.contenido {
  font-size: 14px;
  height: 32px;
  margin: 90px 0px 0px -19px;
}
.item{
  color: white;
//  text-decoration: none;
}
.item:hover{
  background: #596dac ;
  padding: 0;
  border-radius: 0px 5px 5px 0px;
}
b-nav-item:active{
  background: #596dac ;
  padding: 0;
  border-radius: 0px 5px 5px 0px;
}
.imagen{
  width: 21px;
  margin-right: 10px;
  margin-left: 17px;
}
.sesion-item{
  color:#1C3FAA;
  font-size: 15px;
}
.router-link-active{
  background: #596dac !important;
  border-radius: 0px 5px 5px 0px;
}

</style>
